import { default as muiDefaultShadows } from "@mui/material/styles/shadows.js";
export const createShadows = (tokens) => {
    const { low, medium, high } = tokens.core.shadow;
    const defaultShadows = muiDefaultShadows;
    const shadows = [...defaultShadows];
    // Replacing closest Material elevation shadows with Atlas ones
    shadows[3] = low.value.stringValue;
    shadows[6] = medium.value.stringValue;
    shadows[12] = high.value.stringValue;
    return shadows;
};
//# sourceMappingURL=shadows.js.map